import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';

export namespace SymbolAssetsAction {
  const actionCreator = actionCreatorFactory('SymbolAssets');

  export const load = actionCreator.async<{ search?: string }, string[], IApiErrorParams>('LOAD_ASSETS');

  export const destroy = actionCreator('DESTROY');
}
